<template>
  <div
    v-if="timelineStore.pathwayData && !isMultiple"
    data-cy="pathway-info-panel"
    class="columns pt-2"
  >
    <div class="column pb-1">
      <n-tag
        data-cy="pathway-info-census-date-tag"
        icon="calendar"
        label="Census Date"
        :value="timelineStore.censusDate"
      />
      <n-tag
        data-cy="pathway-info-id-tag"
        icon="key"
        label="Pathway ID"
        :value="timelineStore.pathwayData.ID"
      />
      <n-tag
        data-cy="pathway-info-start-date-tag"
        icon="calendar"
        label="Start Date"
        :value="getFriendlyDate(timelineStore.pathwayData['Start Date'])"
      />
      <n-tag
        v-if="timelineStore.pathwayData['Start Date']"
        data-cy="pathway-info-end-date-tag"
        icon="calendar"
        label="End Date"
        :value="getFriendlyDate(timelineStore.pathwayData['Stop Date'] || 'None')"
      />
      <n-tag
        data-cy="pathway-info-specialty-tag"
        icon="briefcase-medical"
        label="Specialty"
        :value="timelineStore.pathwayData.Specialty"
      />
      <n-tag
        data-cy="pathway-info-clinician-tag"
        icon="stethoscope"
        label="Clinician"
        :value="timelineStore.pathwayData.Clinician"
      />
    </div>
  </div>

  <div
    v-else-if="isMultiple"
    class="multiple-tag pt-2"
    data-cy="pathway-info-panel-multiple"
    @click="goToMasterRecords"
  >
    <n-tag
      data-cy="pathway-info-multiple-tag"
      icon="key"
      label="Pathway ID"
      value="Multiple"
      value-style="link"
      :click-to-copy="false"
    />
  </div>
</template>

<script setup>
import useTimelineStore from '@/store/modules/timeline'
import NTag from '@/components/ui/n-tag/n-tag.vue'
import { computed } from 'vue'
import { getFriendlyDate } from '@/mixins/n-time'

const timelineStore = useTimelineStore()

const isMultiple = computed(() => {
  return timelineStore.currentIDs.PTLUniqueID?.length > 1
})

const goToMasterRecords = () => {
  // Scroll to the bottom of the page
  window.scrollTo(0, document.body.scrollHeight)
  // Update the selected tab in the timeline store
  timelineStore.eventViewerTab = 'records'
}
</script>
<style scoped>
.multiple-tag * {
  pointer-events: none !important;
}
</style>
